export enum OfferRequestStatusEnum {
  UNKNOWN = "unknown",
  PENDING = "pending",
  APPROVED = "approved",
  DECLINED = "declined",
}
